export const LoanPipelinesSignalRMessageType = {
  CONNECT_TO_LOANS: 'connectToLoans',
  UPDATE_LOANS_CONNECTION: 'updateLoansConnection',
  DISCONNECT_FROM_LOANS: 'disconnectFromLoans',
};

export const LoanPipelinesSignalREventType = {
  LOAN_PIPELINE_CREATED: 'LoanPipelineCreated',
  LOAN_PIPELINE_MODIFIED: 'LoanPipelineModified',
  LOAN_PIPELINE_DELETED: 'LoanPipelineDeleted',
  LOAN_PIPELINE_REBUILT: 'LoanPipelineRebuilt',
  LOAN_PIPELINES_REORDERED: 'LoanPipelinesReordered',
  ENTITIES_CHANGED_IN_PIPELINE: 'EntitiesChangedInPipeline',
};

export const LoanPipelinesEmitterEventType = {
  RE_FETCH_ENTITIES: 'RE_FETCH_ENTITIES',
  RE_FETCH_KANBAN: 'RE_FETCH_KANBAN',
  SET_STATS_FILTER: 'setStatsFilter',
  CLEAR_STATS_FILTER: 'clearStatsFilter',
  CONTENT_SCROLLED: 'contentScrolled',
};

export const LoanPipelineRepresentationViewType = {
  LOAN: 'Loans',
  TASK: 'Tasks',
  CONDITION: 'Conditions',
  EXTERNAL_DATA: 'ExternalData',
  CONTACT: 'Contacts',
  SUB_COMPANY: 'SubCompanies',
  DRAW_REQUEST: 'DrawRequests',
};

export const LoanPipelineNodeType = {
  PIPELINE: 'Pipeline',
  GROUP: 'Group',
};

// Nesting is groups-only and UI-capped at 3 levels (root, mid, leaf); the data model
// (self-FK, no CHECK constraint) supports more — lift this without a migration.
export const MAX_PIPELINE_TREE_DEPTH = 3;

export const LoanPipelineColumnValueType = {
  STRING: 'String',
  INTEGER: 'Integer',
  DECIMAL: 'Decimal',
  DATE_TIME: 'DateTime',
  LOAN_STATUS: 'LoanStatus',
  MILESTONE_STATUS: 'MilestoneStatus',
  CONDITION_SIGN_OFF_BUTTON: 'ConditionSignOffButton',
  CURRENCY: 'Currency',
  PERCENT: 'Percent',
  FRACTIONAL_PERCENTAGE: 'FractionalPercentage',
  PROGRESS_PERCENTAGE: 'ProgressPercentage',
  AUS_DECISIONS: 'AusDecisions',
};

export const LoanPipelineColumnDisplayMode = {
  RELATIVE_DAYS: 'RelativeDays',
};

export const LoanPipelineSpecificColumnId = {
  LOAN_STATUS: '4b6b0d95-b03c-41d1-b967-02966391ca27',
  LOAN_NUMBER: 'ecc65797-6c03-4bd7-9a75-b44f92fb2f96',
  MILESTONE_STATUS: '0a2fac26-9a56-4c75-a331-a156663fc476',
  APPLICATION_LAST_MODIFIED: 'c221b65f-e807-4181-9482-40a48ce5dc73',
  TASK_NAME: '77c31269-b201-460f-b1a2-3d2649e041cd',
  TASK_STATUS: 'c647ad66-2dd5-48e2-88c2-4aa291d144be',
  TASK_USER_NOTE: 'df66c61f-1f4e-4c8a-a113-e72d60186d42',
  TASK_SUBMITTED_TEXT: '22e7ba86-6da0-4e62-b2a7-0b0f62b0a5e2',
  TASK_LAST_MODIFIED: '59b5b66a-e62f-413e-b245-dfdf48bbf565',
  TASK_SLA_LEVEL_DETAILS: '45879622-2f9f-48e2-be3f-9b3eea10c94c',
  CONDITION_DATE_ADDED: '2724efdd-afa4-4fa6-87e2-62ebfe3a9802',
  CONDITION_TASK_IDS: '30bad861-0ab4-4a62-98b4-79d378a21320',
  CONDITION_SLA_INFO: '2f126629-efa7-4d3c-b03f-0e2be878e219',
  CONDITION_CAN_BE_SIGNED_OFF: '87795b3d-a686-45dc-8209-0d17829e1ea5',
  CONDITION_MESSAGE: 'ddfd0766-0195-4fed-bed1-a57f99ce8fa4',
  INTEREST_RATE: 'a6012bf9-b42e-4227-b313-572890a86432',
  ANTICIPATED_CLOSING_DATE: '77e70f1f-2c31-499a-80b2-dcef697ce080',
  PROGRESS_PERCENTAGE: 'b96a658d-e711-4086-973d-4b6b583686a5',
  PRIMARY_BORROWER_NAME: '82961b64-52c1-4d51-9ab1-c58e44053258',
  APPLICATION_STATUS: '63ccd347-990d-45c0-8834-845cb65798ad',
  FULL_ADDRESS: '67e0e9d6-4bcd-49f7-b4fe-932bceb84575',
  LOAN_PURPOSE: '06563cb8-0317-4a32-a47d-e0c0b2341047',
  AUS_DECISIONS: '76ce1b87-f6a2-4ca2-944c-b0cfeff91165',
  LOCK_EXPIRATION_STATUS: '5b540613-493e-4b59-ba0f-5f4962f67c81',
  LOAN_ROLE: 'd5b7a459-10d8-4bef-b954-3c119f147687',
  TAG_ASSIGNED_DATE: 'eb3650d6-d97b-42b9-a394-16660fa78244',
  DOCUMENT_EXTRACTION: 'e32e8049-ac28-4c42-a944-5c189b32bc88',
  CONTACT_MODIFIED_DATE: '7fa78e70-fa81-4d23-a9bb-3ea053190cad',
  SUB_COMPANY_NAME: 'eabba212-9226-4f0d-b9a6-39749eddd7bb',
  LOANS_AT_MILESTONE: 'e1cdd950-59d7-4106-8a61-2b1cebb213b9',
  SUB_COMPANY_STATUS: 'c4f1f1ee-2d1d-4f74-9bd5-9c1f3a6c0d01',
  SUB_COMPANY_DISPLAY_NAME: 'd2e3a7b8-1c91-4af1-9fa2-2d6b5e2a4f02',
  INVESTOR_LOCK_EXPIRATION_DATE: '68416f25-b3ee-42a3-81ba-b0cf06235fa9',
  INVESTOR_SUBMISSION_DATE: 'a0375140-b0ef-47ae-beee-313356370a18',
};

export const TpoEntityStatus = {
  SIGNUP_IN_PROGRESS: 'SignupInProgress',
  SIGNUP_SUBMITTED: 'SignupSubmitted',
  ACTIVE: 'Active',
  REJECTED: 'Rejected',
  WITHDRAWN: 'Withdrawn',
  INACTIVE: 'Inactive',
};

// Columns holding a calendar date the user picked, not an instant. Reading them in the viewer's zone
// moved the date — 4:00 AM east of UTC, the previous day in the US — so they are read as UTC, rendered
// bare and filtered by the date itself. Add a column id here to opt it into that handling (FH-1194).
export const dateOnlyPipelineColumns = [
  LoanPipelineSpecificColumnId.ANTICIPATED_CLOSING_DATE,
  LoanPipelineSpecificColumnId.LOCK_EXPIRATION_STATUS,
  LoanPipelineSpecificColumnId.INVESTOR_LOCK_EXPIRATION_DATE,
  LoanPipelineSpecificColumnId.INVESTOR_SUBMISSION_DATE,
];

// DateTime columns that must NOT offer the relative-days mode — their cells render something
// other than the raw date (Lock Status renders a traffic-light status from the same value), so
// a day count would replace that rendering with a meaningless number.
export const relativeDaysExcludedColumns = [LoanPipelineSpecificColumnId.LOCK_EXPIRATION_STATUS];

export const lazyLoadedPipelineColumns = [
  LoanPipelineSpecificColumnId.CONDITION_SLA_INFO,
  LoanPipelineSpecificColumnId.CONDITION_CAN_BE_SIGNED_OFF,
];

export const LoanPipelineDefaultView = {
  TABLE: 'Table',
  KANBAN: 'Kanban',
};

export const LOAN_PIPELINES_DEFAULT_PAGE_SIZE = 25;

export const LoanPipelinesFilterType = {
  RANGE: 'Range',
  SINGLE_VALUE: 'SingleValue',
};

// Synthetic filter values for the Lock Status column: the column stores the raw lock expiration
// date, so each status is translated to a date band at request time (getLockStatusFilterRange).
export const LockStatusFilterValue = {
  ACTIVE: 'Active',
  EXPIRING_SOON: 'ExpiringSoon',
  EXPIRED: 'Expired',
};

export const KANBAN_MAX_CARD_FIELDS = 8;

export const PIPELINE_VIEW_MODE_KEY_PREFIX = 'pipeline-view-mode-';

// Keys of the per-column `metadata` bag on a pipeline's viewColumns (loans.LoanPipelineColumnSetting).
export const PipelineColumnMetadataKey = {
  LOCK_STATUS_WARNING_THRESHOLD_DAYS: 'LockStatusWarningThresholdDays',
  DISPLAY_MODE: 'DisplayMode',
};

export const DEFAULT_LOCK_STATUS_THRESHOLD_DAYS = 7;

export const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// DEV-4550: shared between the WidgetThresholds shape (stats-bar widgets) and the
// navigator's pipeline count/SLA badge coloring — both resolve a value against the
// same amber/red threshold direction.
export const ThresholdDirection = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
};

export const ThresholdColor = {
  GREEN: 'green',
  AMBER: 'amber',
  RED: 'red',
};
